import TimelineIcon from "@mui/icons-material/Timeline";
import PublicIcon from "@mui/icons-material/Public";
import PieChartIcon from "@mui/icons-material/PieChart";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StorageIcon from "@mui/icons-material/Storage";
import image1 from '../../../images/Network_Analysis.PNG';
import image2 from '../../../images/TF-IDF.PNG';
import image3 from '../../../images/Word_Embedding_Vectors_for_arthur_balfour_5410_and_benjamin_disraeli_35231.PNG';

// All gallery examples with their full case study details
export const galleryExamples = [
  {
    id: 1,
    title: "US Congressional Discourse",
    description: "Analysis of language patterns in congressional debates over time",
    type: "Time Series",
    icon: <TimelineIcon sx={{ fontSize: 40, color: "#3b82f6" }} />,
    // Extended case study details for modal
    details: "This comprehensive analysis examines the evolution of political discourse in the United States Congress over the past century. Using advanced natural language processing techniques, we identify key themes, sentiment trends, and rhetorical strategies employed by legislators across different eras and party affiliations.",
    image: image1,
    buttons: [
      {
        label: "View Visualization",
        variant: "contained",
        color: "primary",
        path: "/graphs/search" //link to it on visualization search page
      },
      {
        label: "View Dataset",
        variant: "outlined",
        color: "primary",
        path: "/datasets/search"
      },
    ]
  },
  {
    id: 2,
    title: "Global Democracy Index",
    description: "Comparative visualization of democracy metrics across countries",
    type: "Geographic",
    icon: <PublicIcon sx={{ fontSize: 40, color: "#10b981" }} />,
    details: "An interactive exploration of democratic indicators worldwide, tracking changes in political freedoms, civil liberties, and institutional quality across 195 countries from 1990 to present. The visualization reveals regional patterns and helps identify factors that strengthen or undermine democratic governance.",
    image: image2,
    buttons: [
      {
        label: "View Visualization",
        variant: "contained",
        color: "primary",
        icon: <VisibilityIcon />,
        path: "/graphs/search"
      },
      {
        label: "Explore Data",
        variant: "outlined",
        color: "primary",
        icon: <StorageIcon />,
        path: "/datasets/search"
      }
    ]
  },
  {
    id: 3,
    title: "Voter Demographics",
    description: "Detailed breakdown of voter participation by various demographic factors",
    type: "Multi-dimensional",
    icon: <PieChartIcon sx={{ fontSize: 40, color: "#8b5cf6" }} />,
    details: "A multi-dimensional analysis of voting patterns across age, income, education, and geographic location. This study reveals insights into voter turnout disparities and helps identify communities with lower civic engagement that may benefit from targeted outreach efforts.",
    image: image3,
    buttons: [
      {
        label: "View Visualization",
        variant: "contained",
        color: "primary",
        icon: <VisibilityIcon />,
        path: "/graphs/search"
      },
    ]
  },
  {
    id: 4,
    title: "Political Network Analysis",
    description: "Network visualization of political relationships and affiliations",
    type: "Network",
    icon: <AccountTreeIcon sx={{ fontSize: 40, color: "#f59e0b" }} />,
    details: "This network analysis maps the complex web of relationships between political actors, interest groups, and policy outcomes. By analyzing collaboration patterns, voting records, and public statements, we identify influential nodes and communities within the political landscape.",
    image: image1,
    buttons: [
      {
        label: "View Visualization",
        variant: "contained",
        color: "primary",
        icon: <VisibilityIcon />,
        path: "/graphs/search"
      },
    ]
  },
];